<script setup lang="ts">
/**
 * Error page for `ErrorCode.NoIssInAuthResponse` — the `iss` (issuer)
 * parameter was missing from the OAuth callback. RFC 9207 requires the
 * authorization server to return `iss` so the client can guard against
 * issuer-confusion attacks. Delegates all rendering to `AuthErrorView`.
 */
import AuthErrorView from '@/components/errors/AuthErrorView.vue'
import { ErrorCode } from '@/errors/codes'
</script>

<template>
  <AuthErrorView :code="ErrorCode.NoIssInAuthResponse" />
</template>
